"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=DeleteBucketInput.js.map